var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.045 13.836C12.961 13.824 12.853 13.824 12.757 13.836C10.645 13.764 8.96497 12.036 8.96497 9.91201C8.96497 7.74001 10.717 5.97601 12.901 5.97601C15.073 5.97601 16.837 7.74001 16.837 9.91201C16.825 12.036 15.157 13.764 13.045 13.836Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9876 21.7562C18.8516 23.7122 16.0196 24.9002 12.8996 24.9002C9.7796 24.9002 6.9476 23.7122 4.8116 21.7562C4.9316 20.6282 5.6516 19.5242 6.9356 18.6602C10.2236 16.4762 15.5996 16.4762 18.8636 18.6602C20.1476 19.5242 20.8676 20.6282 20.9876 21.7562Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 24.9C19.5274 24.9 24.9 19.5274 24.9 12.9C24.9 6.2726 19.5274 0.900024 12.9 0.900024C6.27258 0.900024 0.900002 6.2726 0.900002 12.9C0.900002 19.5274 6.27258 24.9 12.9 24.9Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.28b02fd8c7c6bcdda5d974b7d6a8f878.svg";
export { ForwardRef as ReactComponent };